var React = require('react');

function IconChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M388.819,239.537L156.092,6.816c-9.087-9.089-23.824-9.089-32.912,0.002\r\n\tc-9.087,9.089-9.087,23.824,0.002,32.912l216.27,216.266L123.179,472.272c-9.087,9.089-9.087,23.824,0.002,32.912\r\n\tc4.543,4.544,10.499,6.816,16.455,6.816c5.956,0,11.913-2.271,16.457-6.817L388.819,272.45c4.366-4.364,6.817-10.283,6.817-16.455\r\n\tC395.636,249.822,393.185,243.902,388.819,239.537z"}));
}

IconChevronRight.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"32px","height":"32px","viewBox":"0 0 512.001 512.001","style":{"enableBackground":"new 0 0 512.001 512.001"},"xmlSpace":"preserve"};

module.exports = IconChevronRight;

IconChevronRight.default = IconChevronRight;
